import { render, staticRenderFns } from "./bulkUpload.vue?vue&type=template&id=a061d3ce&scoped=true"
import script from "./bulkUpload.vue?vue&type=script&lang=js"
export * from "./bulkUpload.vue?vue&type=script&lang=js"
import style0 from "./bulkUpload.vue?vue&type=style&index=0&id=a061d3ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a061d3ce",
  null
  
)

export default component.exports